module.exports = __webpack_public_path__ + "static/EGR_FlashPage_5-149166c3853a367c2c28134e3d929484.jpg";